import { ref, onMounted, onBeforeUnmount } from 'vue'

export function useResponsive() {
  const isMobile = ref(false)
  const isTablet = ref(false)
  const isDesktop = ref(false)
  
  const checkScreenSize = () => {
    const width = window.innerWidth
    
    isMobile.value = width < 640 // Tailwind's 'sm' breakpoint
    isTablet.value = width >= 640 && width < 1024 // Between 'sm' and 'lg'
    isDesktop.value = width >= 1024 // Tailwind's 'lg' breakpoint and above
  }
  
  onMounted(() => {
    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)
  })
  
  onBeforeUnmount(() => {
    window.removeEventListener('resize', checkScreenSize)
  })
  
  return {
    isMobile,
    isTablet,
    isDesktop
  }
}
